<template>
  <div class="c-child-page-ctas">
    <div class="c-child-page-ctas__inner">
      <div v-if="!items.length" class="c-child-page-ctas__content">
         <p class="c-child-page-ctas__text">
           {{options.noResultsText}}
         </p>
      </div>
      <div v-if="items.length" class="c-child-page-ctas__content">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="c-child-page-ctas__cell"
        >
          <Spotlight
            v-bind:date="item.date"
            v-bind:image="item.imageUrl"
            v-bind:link="item.pageUrl"
            v-bind:showSummary="index < 2"
            v-bind:summary="item.summary"
            v-bind:theme="theme"
            v-bind:title="item.title"
          />
        </div>
      </div>
      <div v-show="items.length" class="c-child-page-ctas__actions">
        <button
          v-if="options.loadMoreText &&
          currentPage < totalPages"
          @click="loadItems"
          class="c-child-page-ctas__button"
        >
          {{ options.loadMoreText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import endpoints from "Globals/mando.endpoints";
import Spotlight from "../spotlight/Spotlight.vue";

export default {
  name: "ChildPageCtas",
  components: { Spotlight },
  props: {
    componentId: {
      type: String,
      required: true,
    },
    pageId: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    theme: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      items: [],
      currentPage: 0,
      totalPages: null,
    };
  },
  methods: {
    loadItems() {
      this.currentPage++;
      this.getLocations(
        `${endpoints("getChildPageCtas")}?componentId=${
          this.componentId
        }&pageId=${this.pageId}&page=${this.currentPage}`
      );
    },
    getLocations(endpoint) {
      axios({
        method: "get",
        url: endpoint,
      })
        .then((response) => {
          this.totalPages = response.data.totalPages;
          this.items = [...this.items, ...response.data.results];
        })
        .catch((error) => console.error(error));
    },
  },
  mounted() {
    this.loadItems();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/components/developers/child-page-ctas/ChildPageCtas.vue